// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__ZB6d_","row":"Node_row__2hZ2d","label":"Node_label__36bN3","footer":"Node_footer__2JI29"};